<template>
  <div>
    <p>Copyright © 2013 - {{ thisYear }} simplyBrand. All Rights Reserved 沪ICP备13030473号-1</p>
  </div>
</template>

<style scoped>
p{
  color: rgba(255,255,255,0.50);
  text-align: center;
  margin: 0;
  padding: 30px 0;
  border-top: 1px solid rgba(153,153,153,0.50);
}
</style>

<script>
export default {
  data(){
    return{
      thisYear: ""
    }
  },
  mounted(){
    this.thisYear= this.getThisYear()
  },
  methods: {
    getThisYear: function(){
      let newDate = new Date();
      return newDate.getFullYear()
    }
  }
}
</script>